<div class="container">
  <h3>
    {{
      '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.POSSIBLE_CAUSE' | translate
    }}
  </h3>
  <ng-container *ngFor="let cause of causes">
    <ng-container *ngIf="cause?.cause">
      <ul class="cause-list">
        <li *ngFor="let cause of cause.cause | htmlExtractor: 'p':HTMLExtractionPrefix.DASH">
          {{ cause }}
        </li>
      </ul>
    </ng-container>
  </ng-container>
</div>
